export default __webpack_public_path__ + "static/media/Scope-7.ae1a19b3.png";